import LearningTimeDonut from '@Components/LearningTimeDonut/LearningTimeDonut'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import styled from 'styled-components'

const LearningTimeWidget = () => {
	const { id } = useParams<{ id: string }>()
	const [t] = useTranslation('classroomsOverview')

	return (
		<Wrapper>
			<Header>{t('learningTime')}</Header>
			<LearningTimeDonut scope={{ classroom_id: Number(id) }} />
		</Wrapper>
	)
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`
const Header = styled.p`
	font-weight: 600;
	color: #251b33;
	font-size: 0.75rem;
	${({ theme }) => `${theme.mediaQueries.large}{
		font-size: 1.125rem;
	}`}
`

export default LearningTimeWidget
